export type Mode = "ACQ" | "DIV"
// Blank is a first-class value (some rows are legitimately null); a fresh row
// starts blank so we never stamp a value the user didn't pick.
export type InterestType = "" | "PT" | "HBP"

export interface RowState {
  id: string
  mode: Mode
  transaction_date: string // YYYY-MM-DD
  str: string
  county: string
  net_acres: string
  nri_percent: string // ACQ
  nri_assigned_percent: string // DIV
  arti: boolean // DIV
  override_orri: boolean // DIV
  manual_orri_percent: string // DIV
  interest_type: InterestType // detail
  counterparty: string
  depths: string
  price: string
  book_page: string
  notes: string
  expanded: boolean
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

export function makeEmptyRow(): RowState {
  return {
    id: crypto.randomUUID(),
    mode: "ACQ",
    transaction_date: todayIso(),
    str: "",
    county: "",
    net_acres: "",
    nri_percent: "",
    nri_assigned_percent: "",
    arti: false,
    override_orri: false,
    manual_orri_percent: "",
    interest_type: "",
    counterparty: "",
    depths: "",
    price: "",
    book_page: "",
    notes: "",
    expanded: false,
  }
}
